import JobPosting from "../../../../src/pages/use-cases/page-content/content-publishing/job-posting.md";
import * as React from 'react';
export default {
  JobPosting,
  React
};